import { FC } from 'react';
import { IFieldProps } from './ServiceRenderer';

const InfoBoxField: FC<IFieldProps> = () => {
    return <div>TODO: InfoBox</div>;
};

export default InfoBoxField;
